import { cn } from "@Eikochain/utils"
import { HTMLAttributes } from "react"

export default function Paragraph ({ className, ...props }: HTMLAttributes<HTMLParagraphElement>) {
  return (
    <p className={cn("text-slate-600 text-sm", className)} {...props} />
  )
}
